import { Box, Stack, useMantineTheme } from '@mantine/core';

import repeat from '~/common/utils/repeat';

import { SectionTitleSkeleton } from '../SectionTitleSkeleton/SectionTitleSkeleton';

import { useStyles } from './BrowseSkeleton.styles';

function CardSkeleton() {
  const { classes, cx } = useStyles();

  return (
    <div className={classes.card}>
      <div className={classes.cardHeader}>
        <Box className={cx(classes.skeleton, classes.dateText)} />
        <div className={classes.marketHeaders}>
          {repeat(3, (i) => (
            <Box key={i} className={cx(classes.skeleton, classes.marketHeader)} />
          ))}
        </div>
      </div>

      <div className={classes.teamsContainer}>
        {repeat(2, (teamIndex) => (
          <div key={teamIndex} className={classes.teamRow}>
            <Box className={cx(classes.skeleton, classes.teamLogo)} />
            <div className={classes.teamInfo}>
              <Box className={cx(classes.skeleton, classes.teamName)} />
              <Box className={cx(classes.skeleton, classes.teamRecord)} />
            </div>
            <div className={classes.marketCells}>
              {repeat(3, (cellIndex) => (
                <Box key={cellIndex} className={cx(classes.skeleton, classes.marketCell)} />
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className={classes.footer}>
        <Box className={cx(classes.skeleton, classes.footerLink)} />
      </div>
    </div>
  );
}

export function BrowseSkeleton() {
  const { classes, cx } = useStyles();
  const theme = useMantineTheme();

  return (
    <Stack spacing={theme.other.spacing._24}>
      {repeat(2, (sectionIndex) => (
        <div
          key={sectionIndex}
          className={cx(classes.section, sectionIndex >= 2 && classes.hideOnMobile)}
        >
          <div className={classes.sectionInner}>
            <SectionTitleSkeleton />
            <div className={classes.cardsGrid}>
              {repeat(3, (cardIndex) => (
                <CardSkeleton key={cardIndex} />
              ))}
            </div>
          </div>
        </div>
      ))}
    </Stack>
  );
}
